"use client";
import { useState } from "react";
import "./index.scss";
import GoalOddEvenOdds from "../GoalOddEvenOdds";
import CorrectScoresOdds from "../CorrectScoresOdds";
import TotalCornersOdds from "../TotalCornersOdds";

export const TAB_IDS = {
  FIRST_TAB: "FIRST_TAB",
  SECOND_TAB: "SECON_TAB",
};

export const displayValue = (value) => {
  return value ? value : "-";
};

export const StatusComponent = ({ trend }) => {
  const renderClasses = (trend) => {
    switch (trend) {
      case "unchanged":
        return "";
      case "decreased":
          return "border-t-vibrant-red border-t-[0.54rem]";
      case "increased":
        return "border-b-medium-green border-b-[0.54rem]";
      default:
        return "";
    }
  };

  return (
    trend && (
      <span
        className={`w-0 h-0 border-l-[0.3125rem] border-r-[0.3125rem] border-l-transparent border-r-transparent ${renderClasses(trend)}`}
      ></span>
    )
  );
};

const isEmptyArray = (array) => {
  return array && array.length === 0;
};

export default function OtherBetsDropdown({
  goalOddEvenOdds,
  correctScoresOdds,
  totalCornersOdds,
  correctScoresHalfOdds,
  totalCornersHalfOdds,
}) {
  const [activeTab, setActiveTab] = useState(TAB_IDS.FIRST_TAB);
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const selectAndDisplayOdds = (odds) => {
    return odds;
  };
  
  return (
    <div className="other-bets-dropdown-container rounded w-full mx-auto overflow-x-auto">
      <div className="min-w-auto">
      <ul id="tabs" className="inline-flex @lg:pt-2 @lg:px-1 w-full @lg:border-b @lg:mb-4 @max-sm:gap-2 @max-sm:h-[26px]">
        <li
          className={`@max-sm:flex @max-sm:items-center @max-sm:justify-center @max-sm:basis-1/3 px-4 min-w-[5rem] font-semibold py-2 rounded-t ${
            activeTab === TAB_IDS.FIRST_TAB
              ? "bg-[var(--theme-primary)] text-white font-semibold"
              : "bg-[var(--theme-bg)] text-[var(--theme-text)] hover:opacity-90 font-medium"
          }`}
        >
          <button onClick={() => handleTabClick(TAB_IDS.FIRST_TAB)}>
            Cả trận
          </button>
        </li>
        <li
          className={`@max-sm:flex @max-sm:items-center @max-sm:justify-center @max-sm:basis-1/3 px-4 font-semibold py-2 rounded-t ${
            activeTab === TAB_IDS.SECOND_TAB
              ? "bg-[var(--theme-primary)] text-white font-semibold"
              : "bg-[var(--theme-bg)] text-[var(--theme-text)] hover:opacity-90 font-medium"
          }`}
        >
          <button
            onClick={() => handleTabClick(TAB_IDS.SECOND_TAB)}
          >{`Hiệp 1`}</button>
        </li>
        <li className="@max-sm:block @lg:hidden basis-1/3 hidden">
       </li>
      </ul>

      <div id="tab-contents">
        <div
          className={`${
            activeTab === TAB_IDS.FIRST_TAB ? "visible" : "hidden"
          }`}
        >
          <div className="flex flex-col @lg:gap-1 @lg:p-2">
            {!isEmptyArray(goalOddEvenOdds) && (
              <GoalOddEvenOdds
                goalOddEvenOdds={selectAndDisplayOdds(goalOddEvenOdds)}
              />
         )} 
            {!isEmptyArray(correctScoresOdds) && (
              <CorrectScoresOdds
                correctScoresOdds={selectAndDisplayOdds(correctScoresOdds)}
              />
            )}
           
            {!isEmptyArray(totalCornersOdds) && (
              <TotalCornersOdds
                totalCornersOdds={selectAndDisplayOdds(totalCornersOdds)}
              />
            )}
          </div>
        </div>
        <div
          className={`${
            activeTab === TAB_IDS.SECOND_TAB ? "visible" : "hidden"
          }`}
        >
          <div className="flex flex-col @lg:gap-1 @lg:p-2">

            {!isEmptyArray(correctScoresHalfOdds) && (
              <CorrectScoresOdds
                correctScoresOdds={selectAndDisplayOdds(correctScoresHalfOdds)}
              />
            )}
            {!isEmptyArray(totalCornersHalfOdds) && (
              <TotalCornersOdds
                totalCornersOdds={selectAndDisplayOdds(totalCornersHalfOdds)}
              />
            )}
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}